"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Gabe Kelley, Nick Howland, Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1774))
 * @lastsynced 2026-10-29T13:49:45.184Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const Check = createSVGIcon(
  <path
    d="m2 14.273 4.206 5.16c.142.174.322.315.528.413a1.6 1.6 0 0 0 1.331.019c.21-.092.394-.228.541-.398L22 4"
    strokeLinecap="round"
    strokeLinejoin="round"
    stroke="currentColor"
  />,
  "Check",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    color: iconColor.primary,
    className: iconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
